import React from 'react'

import Text from 'components/common/Text'
import { Color } from 'constants/color'

import { Container } from './styles'

const Timer = ({ max = 30, value = 0, hide = false }) => {
    if (hide) return null
    return (
        <Container>
            <Text color={Color.white} level="4">
                {max - value}
            </Text>
        </Container>
    )
}

export default Timer
